export default class FeedbackQuestionTranslation {
    id: number;
    value: string;
    locale: string;
    Feedback_question_id: number;
}
